module.exports = __webpack_public_path__ + "media/images/partners/depkult2025w-322e16a548a03225ecfb6067511eeb73.svg";